module.exports = __webpack_public_path__ + "static/media/introduction_1.4be66eaf.webp";